exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".user:hover{-webkit-transform:scale(1.08);-ms-transform:scale(1.08);transform:scale(1.08)}.userbox_name{white-space:nowrap}", "", {"version":3,"sources":["/Users/jmac/Downloads/Proj/282021/HT2021/HT2021/hullthread version 2.0/tests/src/components/userBox/userbox.css"],"names":[],"mappings":"AAGA,YACA,8BAA+B,AAC3B,0BAA2B,AACvB,qBAAuB,CAC9B,AAED,cACG,kBAAoB,CACtB","file":"userbox.css","sourcesContent":[".user{\n\n}\n.user:hover{\n-webkit-transform: scale(1.08);\n    -ms-transform: scale(1.08);\n        transform: scale(1.08);\n}\n\n.userbox_name{\n   white-space: nowrap;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/userBox/userbox.css
// module id = 1453
// module chunks = 0 1 2 3 10